<template>
  <div id="callback">
		<div id="header">
			<v-container fill-height>
				<v-row>
					<v-col cols="12" sm="12" md="6" lg="6" xl="6">
						<v-card
							rounded="lg"
							height="400px"
							elevation="24"
							data-aos="fade-right"
						>
							<v-container fill-height>
								<v-form ref="callbackForm">
									<v-row justify="center">
										<div class="text-center px-5 mb-5">
											<div class="display-1 font-weight-black primary--text">Need to talk to a Doctor?</div>
											<p class="py-5">Just enter your contact number and we will call you.</p>
											
											<v-row justify="center">
												<v-col cols="12" sm="12" md="8" lg="8" xl="8">
													<!-- Contact Number -->
													<v-text-field
														label="Contact Number*"
														type="text"
														ref="number"
														v-model="number"
														:rules="[() => !!number || 'This field is required']"
														:error-messages="errorMessages"
													></v-text-field>
												</v-col>
											</v-row>
										</div>
										<v-row justify="center">
											<base-button
												name="Get my callback"
												rounded
												large
												color="#0e6ccd"
												icon="mdi-arrow-right"
												@click="confirmCallbackInfo()"
											></base-button>
										</v-row>
									</v-row>
								</v-form>
							</v-container>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<!-- <div class="divider">
			<v-container>
				<v-row align="center">
					<h3 class="white--text">FREE access for Partner Member</h3>
				</v-row>
			</v-container>
		</div>

		<div id="partners">
			<v-container>
				<v-row justify="center" class="my-5">
				<v-col
					cols="6" sm="6" md="3" lg="3" xl="3"
					v-for="(val, key) in partners"
					:key="key"
					data-aos="fade-up"
				>
					<v-img contain :src="val" height="80px"></v-img>
				</v-col>
			</v-row>
			</v-container>
		</div> -->

		<base-confirm-dialog
			v-model="confirmDialog"
			title="Confirm"
			message="Would you like to send a callback request?"
			@do="saveCallbackInfo()"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You successfully submitted your callback request."
		></base-success-dialog>
  </div>
</template>

<script>
export default {
	name: "Callback",
	
  components: {
	},
	
  data() {
    return {
			/* form fields */
			number: null,
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
			successDialog: false,
			partners: [
				require("@/assets/images/partners/intellicare.png"),
				require("@/assets/images/partners/generali.png"),
				require("@/assets/images/partners/hppi.png"),
				require("@/assets/images/partners/insular.png"),
				require("@/assets/images/partners/pnb.jpg"),
				require("@/assets/images/partners/cocolife.png"),
				require("@/assets/images/partners/avega.png"),
				require("@/assets/images/partners/axa.png")
			]
		}
	},
	
	computed: {
		callbackForm() {
      return {
        number: this.number,
      }
    },
	},

  mounted() {
    //
  },
  methods: {
    confirmCallbackInfo() {
      if (this.$refs.callbackForm.validate()) this.confirmDialog = true;
		},
		saveCallbackInfo() {
			this.confirmDialog = false;

      // try {
      //   let save = await Api.create(this.contactForm);

      //   if (save) {
          this.successDialog = true;
      //     localStorage.removeItem('cartItems');
      //   }
      //   else {
      //     console.log("Sorry, there was a problem saving your transaction.");
      //   }
      // }
      // catch(error) {
      //   console.log(error);
      // }
		}
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

#header {
	background: url("~@/assets/images/banners/banner_01.jpg") no-repeat;
	background-size: cover;
	height: 750px;
}

.divider {
	height: 60px;
	background: $blue;
}
</style>